var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCC0D8;}\n\t.st1{fill:#243193;}\n\t.st2{fill:#E09F0D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.4,484.1h-90.8c-7.6,0-13.8-6.2-13.8-13.8v-71.2h27.6v57.4h63.2v-57.4h27.6v71.2 C315.2,477.9,309,484.1,301.4,484.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,417.6H62.3C27.9,417.6,0,389.7,0,355.4V90.2c0-34.3,27.9-62.3,62.3-62.3h387.5 c34.3,0,62.3,27.9,62.3,62.3v265.2C512,389.7,484.1,417.6,449.7,417.6z M62.3,55.5c-19.1,0-34.7,15.6-34.7,34.7v265.2 c0,19.1,15.5,34.7,34.7,34.7h387.5c19.1,0,34.7-15.5,34.7-34.7V90.2c0-19.1-15.5-34.7-34.7-34.7C449.7,55.5,62.3,55.5,62.3,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362,484.1H150c-7.6,0-13.8-6.2-13.8-13.8s6.2-13.8,13.8-13.8h212c7.6,0,13.8,6.2,13.8,13.8 S369.6,484.1,362,484.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.5,345.2h-71.3c-7.6,0-13.8-6.2-13.8-13.8s6.2-13.8,13.8-13.8h71.3c7.6,0,13.8,6.2,13.8,13.8 S505.1,345.2,497.5,345.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.3,345.2H14.5c-7.6,0-13.8-6.2-13.8-13.8s6.2-13.8,13.8-13.8h343.8c7.6,0,13.8,6.2,13.8,13.8 S365.9,345.2,358.3,345.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.5,277.4c-18.8,0-34-15.3-34-34v-76.8c0-18.8,15.3-34,34-34s34,15.3,34,34v76.8 C247.5,262.1,232.3,277.4,213.5,277.4z M224.8,166.6c0-6.2-5-11.3-11.3-11.3c-6.2,0-11.3,5-11.3,11.3v76.8c0,6.2,5,11.3,11.3,11.3 c6.2,0,11.3-5,11.3-11.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.5,277.4c-18.8,0-34-15.3-34-34V133.6c0-18.8,15.3-34,34-34c18.8,0,34,15.3,34,34v109.7 C332.5,262.1,317.2,277.4,298.5,277.4z M298.5,122.4c-6.2,0-11.3,5-11.3,11.3v109.7c0,6.2,5,11.3,11.3,11.3c6.2,0,11.3-5,11.3-11.3 V133.6C309.7,127.4,304.7,122.4,298.5,122.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.30c64eb26c2754e05efaafcc260d295e.svg";
export { ForwardRef as ReactComponent };